import { TService } from 'types/service';
import { TTopicMessageStats } from './topicMessages';

type TOrderService = {
    id: number;
    workId: number;
    name: string;
    price: number;
    quantity: number;
    min_performers: number;
    total: number;
    type: string;
    assigned_performers_count: number;
    started_at: string | null;
    status: string | null;
    duration: number | null;
    assigned_performers: Array<{
        id: number;
        user: {
            id: number;
            surname: string;
            name: string;
            patronymic: string;
        };
        picture: {
            original: string;
            compressed: string;
        };
    }>;
    /**
     * Сводка по чату заказа для позиции — приходит вместе с ней из
     * `works[].workable.data`. Нет у удалённых строк и у «Работы с товарами».
     */
    messages_count?: TTopicMessageStats['messages_count'];
    last_message?: TTopicMessageStats['last_message'];
};

const normalizeOrderService = (service: TService, quantity: number): TOrderService => {
    return {
        id: service.id,
        name: service.name,
        quantity: quantity,
        price: service.price,
        total: service.price * quantity,
    };
};
export { TOrderService, normalizeOrderService };
